import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationViewModal = ({ isOpen, onClose, item, language, onEdit, onDelete, onSendNow }) => {
  if (!isOpen || !item) return null;

  const labels = {
    title: { en: 'Notification Details', ar: 'تفاصيل الإشعار' },
    titleLabel: { en: 'Title', ar: 'العنوان' },
    message: { en: 'Message', ar: 'الرسالة' },
    targetUsers: { en: 'Target Users', ar: 'المستخدمون المستهدفون' },
    type: { en: 'Notification Type', ar: 'نوع الإشعار' },
    scheduledDate: { en: 'Scheduled Date & Time', ar: 'تاريخ ووقت الجدولة' },
    status: { en: 'Status', ar: 'الحالة' },
    active: { en: 'Active', ar: 'نشط' },
    inactive: { en: 'Inactive', ar: 'غير نشط' },
    edit: { en: 'Edit', ar: 'تعديل' },
    delete: { en: 'Delete', ar: 'حذف' },
    sendNow: { en: 'Send Now', ar: 'إرسال الآن' },
    close: { en: 'Close', ar: 'إغلاق' }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {labels?.title?.[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.titleLabel?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{item?.title}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.message?.[language]}</label>
            <p className="text-base text-foreground mt-1 whitespace-pre-wrap">{item?.message}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.type?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{item?.type}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.targetUsers?.[language]}</label>
            <div className="flex flex-wrap gap-2 mt-2">
              {item?.targetUsers?.map((user, i) => (
                <span key={i} className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/10 text-primary">
                  {user}
                </span>
              ))}
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.scheduledDate?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">
              {new Date(item?.scheduledDate)?.toLocaleString(language === 'ar' ? 'ar-SA' : 'en-US')}
            </p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.status?.[language]}</label>
            <div className="mt-2">
              <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium ${
                item?.active ? 'bg-success/10 text-success' : 'bg-muted text-text-secondary'
              }`}>
                {item?.active ? labels?.active?.[language] : labels?.inactive?.[language]}
              </span>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="success"
              fullWidth
              onClick={onSendNow}
              iconName="Send"
            >
              {labels?.sendNow?.[language]}
            </Button>
          </div>

          <div className="flex gap-3">
            <Button
              variant="outline"
              fullWidth
              onClick={onEdit}
              iconName="Edit2"
            >
              {labels?.edit?.[language]}
            </Button>
            <Button
              variant="destructive"
              fullWidth
              onClick={onDelete}
              iconName="Trash2"
            >
              {labels?.delete?.[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationViewModal;